import { awsApiUrl } from "./analysis";

export const getGroupSimpleBoxPlot = async (
  value,
  header,
  title,
  yLabel,
  xLabel
) => {
  if (!header || !header.length) {
    header = [""];
  }

  const payload = {
    value: value,
    header: header,
    title,
    yLabel,
    xLabel,
    xTicks: header,
  };
  // console.log({
  // 	payload,
  // });

  const res = await fetch(`${awsApiUrl}/getGroupSimpleBoxPlot`, {
    method: "POST",
    body: JSON.stringify({
      arr: value,
      arrTitle: header,
      title,
      yLabel,
      xLabel,
      xTicks: header,
    }),
    headers: {
      "Content-type": "application/json",
    },
  });

  const result = res ? await res.json() : false;
  // console.log("getGroupSimpleBoxPlot: >>", result);
  return result;
};
